import { HStack, VStack, colors } from "goi_common";

interface Row {
  key: string;
  value: string;
}

interface Props {
  header: Row;
  rows: Row[];
}

const PriceTable = ({ header, rows }: Props) => {
  return (
    <VStack
      as="table"
      gap="12px"
      css={{
        backgroundColor: colors.gray700,
        borderRadius: "10px",
        padding: "20px 12px",
      }}
    >
      <thead>
        <HStack
          as="tr"
          justifyContent="space-between"
          css={{
            paddingBottom: "4px",
            borderBottom: `1px solid ${colors.white}`,
          }}
          className="subtitle_16_sb"
        >
          <td>{header.key}</td>
          <td>{header.value}</td>
        </HStack>
      </thead>
      <VStack gap="8px" as="tbody">
        {rows.map((row) => (
          <HStack as="tr" className="body_14_r" justifyContent="space-between" key={row.key}>
            <td>{row.key}</td>
            <td>{row.value}</td>
          </HStack>
        ))}
      </VStack>
    </VStack>
  );
};

export default PriceTable;
